import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse } from '@app/ui';

import shortenStr from '@app/utils/shortenStr';

import './ParametersCollapse.scss';

export const ParametersCollapse = ({
    parameters = [],
}: {
    parameters: { name: string }[];
}) => {
    const { t } = useTranslation(['tools']);
    const _renderTags = params => {
        return (
            <React.Fragment>
                {params.map((name, ind) => {
                    const shortName = shortenStr(20, name);
                    return <p key={`${name}_${ind}`}>{shortName}</p>;
                })}
            </React.Fragment>
        );
    };

    const hasParameters =
        !!parameters && Array.isArray(parameters) && parameters.length > 0;

    const params = useMemo(() => {
        if (!parameters) return [];
        return parameters.map(p =>
            t(`tools:collections.parameterNames.${p.name}`),
        );
    }, [parameters, t]);

    if (!hasParameters) return <></>;

    const [first, ...others] = params;

    if (others?.length) {
        return (
            <Collapse
                expandIconPosition="end"
                className="collapse-container"
                bordered={false}
                key={1}
                items={[
                    {
                        label: _renderTags([first]),
                        key: 1,
                        children: _renderTags(others),
                    },
                ]}
            />
        );
    } else {
        return (
            <div className="ant-collapse collapse-container">
                <p className="ant-collapse-header">{_renderTags([first])}</p>
            </div>
        );
    }
};
